export type Environment = "LOCAL" | "DEV" | "QA" | "PROD";

export interface CheckoutPageEnvironment {
  environment: Environment;
  origin: string;
  customerApiUrl: string;
}

export const localEnvironment: CheckoutPageEnvironment = {
  environment: "LOCAL",
  origin: "localhost",
  customerApiUrl: import.meta.env.VITE_CUSTOMER_API_URL,
};

export const devEnvironment: CheckoutPageEnvironment = {
  environment: "DEV",
  origin: "https://pay.dev.littlepay.com",
  customerApiUrl: "https://checkout.dev1.littlepay.com/customer/v1",
};

export const qaEnvironment: CheckoutPageEnvironment = {
  environment: "QA",
  origin: "https://pay.sandbox.littlepay.com",
  customerApiUrl: "https://checkout.sandbox.littlepay.com/customer/v1",
};

export const prodEnvironment: CheckoutPageEnvironment = {
  environment: "PROD",
  origin: "https://pay.littlepay.com",
  customerApiUrl: "https://checkout.littlepay.com/customer/v1",
};

const checkoutPageEnvironments: CheckoutPageEnvironment[] = [
  devEnvironment,
  qaEnvironment,
  prodEnvironment,
];

export function deriveCheckoutPageEnvironmentFromOrigin(): CheckoutPageEnvironment {
  if (import.meta.env.DEV) {
    return localEnvironment;
  }

  const origin = window.location.origin;
  if (!origin.startsWith("https")) {
    throw new Error("Non-https origin detected");
  }

  const environmentConfig = checkoutPageEnvironments.find((env) => origin.startsWith(env.origin));
  if (!environmentConfig) {
    throw new Error(`Unknown environment for origin: ${origin}`);
  }

  return environmentConfig;
}
